<template>
    <div class="sub-main col" :class="{mobile:$vuetify.breakpoint.xs}">
        <div class="sub-main-content">
            <v-btn class="close_button" small icon @click="del"><v-icon size="14">close</v-icon></v-btn>             
            <v-btn class="right" small icon @click="toggleCompletedSub()">
                {{sub.completed ? "✔️" : "✓" }}
            </v-btn>            
            <!-- <textarea v-model="noticeBody" v-if="low" class="w-100"/> -->
            <div class="roboto-normal-18 clr-black-38 pl-9 pt-3">{{sub.name}}</div>
            <TTextArea v-model="subBody" rows="10" :no-editor="true"/>
        </div>
        <div class="flex-center-between">
            <div class="time">{{moment(+new Date(this.sub.createdAt)).calendar()}}</div>         
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import { debounce } from 'lodash'
    import TTextArea from '../misc/TTextArea'
    import moment from 'moment'
    export default {
        name: 'SubMain',
        components: {
            TTextArea,
        },
        props: [
            'sub',
            // 'low'
        ],
        data() { 
            return {
                
            }
        },
        computed:{
          ...mapGetters(["current", "current_task"]),
            subBody:{
                get(val){
                    return this.sub.body
                },
                set: debounce(function(newVal) {
                    this.editSub({_id: this.current._id, task_id: this.current_task._id, sub_id: this.sub._id, text: newVal})
                }, 450)
            }, 
        },
        methods:{
            ...mapActions(['editSub', 'delSub','setCompletedSub']),
            del(){
                this.delSub({theme_id: this.current._id, task_id: this.current_task._id, sub_id: this.sub._id})         
            },
            moment,
            toggleCompletedSub() {
                this.setCompletedSub({_id: this.current._id, task_id: this.current_task._id, sub_id: this.sub._id, value: !this.sub.completed})
            },
        },
    }
</script>

<style lang="scss" scoped>
    .sub-main.mobile{
        min-width: 100%;  
    }
    .sub-main{
        max-height:352px;
        border: 1px solid #F2F2F2;
        box-sizing: border-box;
        border-radius: 7px;
        .sub-main-content {
            max-height:300px;
            overflow:hidden
        }      
    }
    .time{
        padding-left: 5px;
        font-family: Roboto;
        font-style: italic;
        font-weight: normal;
        font-size: 18px;
        line-height: 23px;
        color: #BEBEBE;
    }
    .close_button{
        float: right;
        opacity: .3;
        &:hover{
            opacity: 1;
        }
    }
</style>